
<template>
    <div class="center">
      <vs-dialog prevent-close v-model="active">
        <template #header>
          <h4 class="not-margin">
            Editar descripción del documento {{selectRow.nombre}}
          </h4>
        </template>


        <div class="con-form">
            <p class="mb-0"><small>FECHA DE VISUALIZACIÓN ACTUAL:</small></p>
            <p><i>{{selectRow.fecha_visualizacion}}</i></p>
            <form autocomplete="off">
                <p class="mt-3 mb-0"><strong>Fecha límite de visualización del documento</strong></p>
                <vs-input
                    type="date"
                    :min="fecha_minima"
                    v-model="fecha_visualizacion"
                >
                    <template #message-danger v-if="errorFields.includes('fecha_limite')">
                        Requerido
                    </template>
                </vs-input>
            </form>
            <hr>
            <p class="mb-0"><small>DESCRIPCIÓN ACTUAL:</small></p>
            <p><i>{{selectRow.descripcion}}</i></p>
            <form autocomplete="off">
                <p class="mt-3"><strong>Actualizar descripción del documento</strong></p>
                <textarea class="vs-input-parent" v-model="descripcion" placeholder="Descripción"></textarea>
                <div v-if="errorFields.includes('descripcion')" class="vs-input__message vs-input__message--danger v-enter-to" style="height: 21px;">
                    Requerido
                </div>
            </form>
        </div>
        <template #footer>
          <vs-row>
              <vs-col sm="6" lg="6">
                <vs-button
                    danger
                    flat>
                    Cancelar
                </vs-button>
              </vs-col>
              <vs-col sm="6" lg="6">
                <vs-button
                    success
                    class="ml-auto">
                    Aceptar
                </vs-button>
              </vs-col>
          </vs-row>
        </template>
      </vs-dialog>
    </div>
</template>
<script>
  export default {
    props:[
        'value',
        'selectRow',
    ],
    data:() => ({
        active: false,
        descripcion: '',
        fecha_visualizacion:'',
        errorFields: []
    }),
    computed:{
        fecha_minima(){
            const date = new Date();
            date.setDate(date.getDate() + 1)
            const day = String(date.getUTCDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0')
            const year = date.getFullYear();
            const fechaAll = year + '-' + month + '-' + day
                return fechaAll
        }
    },
    methods: {
        sanityForm () {
            this.errorFields = []
            if (!this.fecha_limite) {
                this.errorFields.push('fecha_limite')
            }
            if (!this.descripcion) {
                this.errorFields.push('descripcion')
            }
            if (!this.errorFields.length){
                return true
            } else {
                return null
            }
        },
    },
    watch: {
        value (val) {
            this.active = val
        },
        active (val) {
            if (!val){
                this.$emit('input', val);
            }
        },
    }
  }
  </script>

<style scoped>
  .vs-select-content{
    max-width: 100% !important;
}
</style>

        